import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { EMPTY, Observable, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment";
import { UnitAttributes } from "src/models/units/unit-attributes.model";
import { UnitDataService } from "src/services/unit-data.service";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { ResolverHelper } from "./resolver.helper";

export const ValueEstateResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const queryParams = route.queryParams;
    const hasKnr = queryParams.hasOwnProperty("knr");
    const hasBnr = queryParams.hasOwnProperty("bnr");
    const hasGnr = queryParams.hasOwnProperty("gnr");
    const hasOrgnumber = queryParams.hasOwnProperty("organizationNumber");
    const hasShareNumber = queryParams.hasOwnProperty("shareNumber");
    const hasUnitId = queryParams.hasOwnProperty("unitId") || queryParams.hasOwnProperty("unitID");
    const hasEstateId = queryParams.hasOwnProperty("estateId");
    const hasEstateShareId = queryParams.hasOwnProperty("estateShareId");
    const unitDataService = inject(UnitDataService);
    const authService = inject(AuthService);

    return ResolverHelper.hasPermission(authService, [EVServiceType.EvWeb_ValueAssistant]).pipe(
        take(1),
        switchMap((hasValueAssistantRole) => {
            if (!hasValueAssistantRole) {
                redirectToSearchPage();
                return EMPTY;
            }
            if (hasUnitId) {
                const unitId: string =
                    queryParams["unitId"] != null ? queryParams["unitId"].toString() : queryParams["unitID"] != null ? queryParams["unitID"].toString() : "";
                const url = environment.evwebUrl + "/valuateEstate;estateID=null;unitId=" + unitId;
                window.open(url, "_self");
                return EMPTY;
            }
            if (hasEstateId && hasEstateShareId) {
                const estateId: string = queryParams["estateId"] != null ? queryParams["estateId"].toString() : "";
                const estateShareId: string = queryParams["estateShareId"] != null ? queryParams["estateShareId"].toString() : "";
                const addressId: string = queryParams["addressId"] != null ? queryParams["addressId"].toString() : "";
                const url =
                    environment.evwebUrl +
                    "/valuateEstate;estateID=" +
                    estateId +
                    ";estateShareId=" +
                    estateShareId +
                    ";addressID=" +
                    addressId +
                    ";useSale=true";
                window.open(url, "_self");
                return EMPTY;
            }
            if (hasOrgnumber && hasShareNumber) {
                const organizationNumber: string = queryParams["organizationNumber"] != null ? queryParams["organizationNumber"].toString() : "";
                const shareNumber: string = queryParams["shareNumber"] != null ? queryParams["shareNumber"].toString() : "";
                const searchString = organizationNumber + " " + shareNumber;
                return unitDataService.getUnitAttributes(searchString).pipe(
                    switchMap((units: UnitAttributes[]) => {
                        if (units.length == 1) {
                            const url =
                                environment.evwebUrl + "/valuateEstate;orgNumber=" + units[0].organizationNumber + ";shareNumber=" + units[0].shareNumber;
                            window.open(url, "_self");
                        } else {
                            redirectToSearchPage();
                        }
                        return EMPTY;
                    }),
                );
            } else if (hasKnr && hasBnr && hasGnr) {
                const KNr: string = queryParams["knr"] != null ? queryParams["knr"].toString() : "";
                const BNr: string = queryParams["bnr"] != null ? queryParams["bnr"].toString() : "";
                const GNr: string = queryParams["gnr"] != null ? queryParams["gnr"].toString() : "";
                const FNr: string = queryParams["fnr"] != null ? queryParams["fnr"].toString() : "";
                const SNr: string = queryParams["snr"] != null ? queryParams["snr"].toString() : "";
                const searchString = KNr + " " + GNr + " " + BNr + " " + FNr + " " + SNr;
                return unitDataService.getUnitAttributes(searchString).pipe(
                    switchMap((units: UnitAttributes[]) => {
                        //Søk om det finnes noen eiendom på matrikkelen
                        if (units.length == 1) {
                            const url = environment.evwebUrl + "/valuateEstate;estateID=" + units[0].estateID + ";addressID=" + units[0].addressID;
                            window.open(url, "_self");
                        } else {
                            redirectToSearchPage();
                        }
                        return EMPTY;
                    }),
                );
            } else {
                redirectToSearchPage();
                return EMPTY;
            }
        }),
    );

    function redirectToSearchPage() {
        let queryString = "";
        if (hasKnr && hasBnr && hasGnr) {
            const KNr: string = queryParams["knr"] != null ? queryParams["knr"].toString() : "";
            const BNr: string = queryParams["bnr"] != null ? queryParams["bnr"].toString() : "";
            const GNr: string = queryParams["gnr"] != null ? queryParams["gnr"].toString() : "";
            const FNr: string = queryParams["fnr"] != null ? queryParams["fnr"].toString() : "";
            const SNr: string = queryParams["snr"] != null ? queryParams["snr"].toString() : "";
            queryString = KNr + "%20" + GNr + "%20" + BNr + "%20" + FNr + "%20" + SNr;
        } else if (hasOrgnumber) {
            const orgNr: string = queryParams["organizationNumber"] != null ? queryParams["organizationNumber"].toString() : "";
            const shareNumber: string = queryParams["shareNumber"] != undefined ? queryParams["shareNumber"].toString() : "";
            queryString = orgNr + "%20" + shareNumber;
        } else {
            const url = environment.evwebUrl + "/frontpage";
            window.open(url, "_self");
            return;
        }
        const url = environment.evwebUrl + "/searchpage;searchString=" + queryString + ";doSearch=true;";
        window.open(url, "_self");
    }
};
